import { render, staticRenderFns } from "./VODPoolsForm.vue?vue&type=template&id=9b427472&scoped=true&"
import script from "./VODPoolsForm.vue?vue&type=script&lang=js&"
export * from "./VODPoolsForm.vue?vue&type=script&lang=js&"
import style0 from "./VODPoolsForm.vue?vue&type=style&index=0&id=9b427472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b427472",
  null
  
)

export default component.exports